import { AuthService } from "./../../shared/models/auth.service";
import { Injectable, Inject } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { PersonModel, PersonDeleteModel, PersonRemoveModel } from "./person.model";
import { Observable } from "rxjs/Observable";
import { WeGoConfig, IAPIResponse, DataListModel } from "../../shared/config";

@Injectable()
export class PersonService {
  constructor(private authService: AuthService, private http: Http) { }

  public GetPersonList(input?: DataListModel): Observable<IAPIResponse> {
    let getPersonUrl = WeGoConfig.API_GET_PERSON_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getPersonUrl = getPersonUrl + "?" + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getPersonUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetPersonListByAccessRight(
    input: DataListModel,
    pageName: string
  ): Observable<IAPIResponse> {
    let getPersonUrl: string = "";
    switch (pageName) {
      case "COST_EXPENSE_LIST":
        getPersonUrl = WeGoConfig.API_GET_PERSON_LIST_FOR_COST_EXPENSE_LIST;
        break;

      default:
        getPersonUrl = WeGoConfig.API_GET_PERSON_LIST_FOR_COST_EXPENSE_LIST;
        break;
    }
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getPersonUrl = getPersonUrl + "?" + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getPersonUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportPersonList(input?: DataListModel): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getUrl = WeGoConfig.API_EXPORT_PERSON_LIST + "?" + queryString;
    let headers = this.authService.GetHeader("text/csv");
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getUrl, options);
  }

  public GetPersonByHashId(personHashId: string): Observable<IAPIResponse> {
    let getPersonUrl =
      WeGoConfig.API_GET_PERSON_BY_HASH + "?personHashId=" + personHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getPersonUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetAdminList(input?: DataListModel, permissionName?: string): Observable<IAPIResponse> {
    let getAdminUrl = WeGoConfig.API_GET_ADMIN_LIST;
    let queryString = this.authService.HandleAPIListInput(input);

    if (queryString) {
      getAdminUrl = getAdminUrl + "?" + queryString;
      getAdminUrl = getAdminUrl + "&permissionName" + permissionName;
    } else {
      getAdminUrl = getAdminUrl + "?permissionName" + permissionName;
    }

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getAdminUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AddPerson(personModel: PersonModel): Observable<IAPIResponse> {
    let body = personModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_PERSON_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public DeletePerson(PersonDeleteModel: PersonDeleteModel): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    let body = PersonDeleteModel;

    return this.http
      .post(WeGoConfig.API_DELETE_PERSON, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ResetPersonPassword(personHashId: string): Observable<IAPIResponse> {
    let getPersonUrl =
      WeGoConfig.API_RESET_PASSWORD_PERSON + "?personHashId=" + personHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getPersonUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ImportPersonRecord(
    personModel: PersonModel[]
  ): Observable<IAPIResponse> {
    let body = personModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_IMPORT_PERSON_CSV, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ReSendActivationMail(personHashId: string, organizationHashId: string = ""): Observable<IAPIResponse> {
    let getPersonUrl =
      WeGoConfig.API_RESEND_ACTIVATION_MAIL_URL +
      "?personHashId=" +
      personHashId + "&organizationHashId=" + organizationHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getPersonUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdatePersonRemovalDate(personRemoveModel: PersonRemoveModel): Observable<IAPIResponse> {

    let body = personRemoveModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.post(WeGoConfig.API_UPDATE_PERSON_REMOVAL_DATE_URL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);

  }

  public ActivatePerson(personHashId: string): Observable<IAPIResponse> {

    let getPersonUrl =
      WeGoConfig.API_ACTIVATE_PERSON_URL +
      "?personHashId=" +
      personHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getPersonUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);

  }

  public ResetTwoFaCookie(personHashId: string): Observable<IAPIResponse> {
    let getPersonUrl =
      WeGoConfig.API_RESET_TWOFA_COOKIE_PERSON +
      "?personHashId=" +
      personHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getPersonUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ResetTwoFaKey(personHashId: string): Observable<IAPIResponse> {
    let getPersonUrl =
      WeGoConfig.API_RESET_TWOFA_KEY_PERSON +
      "?personHashId=" +
      personHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getPersonUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public CorrectTag(rfidTagId: string): Observable<IAPIResponse> {
    let getCorrectTagUrl = WeGoConfig.API_CORRECT_TAG + "?rfidTagId=" + rfidTagId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getCorrectTagUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }  
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/person/models/person.service.ts